import { Component, computed, HostBinding, input } from '@angular/core'
import { LeaderboardPractice } from '../models'

@Component({
   selector: 'leaderboard-rank-table',
   templateUrl: './leaderboard-rank-table.component.html',
   standalone: false,
})
export class LeaderboardRankTableComponent {
   isRegional = input<boolean>(false)
   title = input<string>('')
   practices = input<LeaderboardPractice[]>([])
   currentPracticeSKey = input<number>(undefined)
   rankField = input<string>('')
   showLinks = input<boolean>(false)
   limit = input<number>(undefined)
   maxHeight = input<string>(undefined)
   filterNoRank = input<boolean>(false)

   @HostBinding('class.constrained-height') get constrainedHeightClass() {
      return !!this.maxHeight()
   }

   currentPractice = computed(() => this.practices()?.find((p) => p.practiceSKey == this.currentPracticeSKey()))

   sortedPractices = computed(() => {
      const practices = [...this.practices()]

      if (!practices) return []
      const sorted = practices
         .filter((p) => !this.filterNoRank() || p.stats[this.rankField()] > 0)
         .sort((a, b) => a?.stats[this.rankField()] - b?.stats[this.rankField()])

      if (!!this.limit()) {
         return sorted.slice(0, this.limit())
      }

      return sorted
   })
}
